import React from 'react'

/**
 * Table with ES debug information about a route.
 * @param {Object} props
 * @param {import("../../entities").Route} props.route
 * @param {import("../../entities").RouteDebugData} props.debugData
 */
const RouteDebugTable = ({ route, debugData }) => (
    <table className="route-debug-table">
        <tbody>
            <tr>
                <td>Score</td>
                <td>{debugData.score}</td>
            </tr>
            <tr>
                <td>Rating</td>
                <td>{route.rating}</td>
            </tr>
            <tr>
                <td>Ratings count</td>
                <td>{debugData.ratingsCount}</td>
            </tr>
            <tr>
                <td>Views</td>
                <td>{route.views}</td>
            </tr>
            <tr>
                <td>Backlinks</td>
                <td>{debugData.backlinksCount}</td>
            </tr>
            <tr>
                <td>Description length</td>
                <td>{debugData.descriptionLength}</td>
            </tr>
            <tr>
                <td>Created</td>
                <td>{route.created.format('DD.MM.YY HH:mm')}</td>
            </tr>
            <tr>
                <td>Comments</td>
                <td>{debugData.commentsCount}</td>
            </tr>
            <tr>
                <td>Riders</td>
                <td>{debugData.ridersCount}</td>
            </tr>
            <tr>
                <td>Flagged</td>
                <td>{debugData.flaggedCount}</td>
            </tr>
            <tr>
                <td>Short route</td>
                <td>{debugData.isShortRoute ? 'Yes' : 'No'}</td>
            </tr>
        </tbody>
    </table>
)

export default RouteDebugTable
